import { render, staticRenderFns } from "./BindersList.vue?vue&type=template&id=30f97fec"
import script from "./BindersList.vue?vue&type=script&lang=js"
export * from "./BindersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports